<template>
  <section class="space-section" id="contact-section">
    <div>
      <b-row class="col-center" :class="animationSendForm">
        <b-col cols="12" sm="10" md="5" lg="5" xl="4">
          <div class="mt-c">
            <span class="ct-title-section gotham-medium">{{ $t("contact.title") }}</span>
            <p class="ct-text gotham-book" style="white-space: pre-line;">
              {{ $t('contact.content') }}
            </p>
            <p class="ct-text gotham-book" style="white-space: pre-line;">
              <a class="footer_hover" href="tel:5540397847" target="_blank">+55 4039 7847</a>
              <br>
              <a class="footer_hover" href="mailto:hello@marabunta.work">hello@marabunta.work</a>
            </p>
          </div>
        </b-col>
        <b-col cols="12" sm="10" md="7" lg="7" xl="7">
          <div class="mt-p">
            <b-form class="gotham-book form-contact" @submit="checkForm" v-if="show">
              <b-row class="my-3 mr-p">
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                  <b-form-input class="input-size" v-model="form.name" :placeholder="$t('contact.name')" required maxlength="50"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-3 mr-p">
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                  <b-form-input class="input-size" v-model="form.email" type="email" :placeholder="$t('contact.email')" required maxlength="50"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-3 mr-p">
                <b-col cols="12" sm="12"  md="12" lg="12" xl="10">
                  <b-form-input class="input-size" v-model="form.issue" :placeholder="$t('contact.issue')" required maxlength="50"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-3 mr-p">
                <b-col cols="12" sm="12" md="12" lg="12" xl="5" class="input-services">
                  <div>
                    <multiselect 
                      v-model="form.value" 
                      :options="options" 
                      :multiple="true" 
                      :close-on-select="false" 
                      :clear-on-select="false" 
                      :preserve-search="true" 
                      :placeholder="$t('contact.services')" 
                      label="name" 
                      track-by="name"
                      :showLabels="false">
                      <template slot="tag"><span v-show="showTags"></span></template>
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} {{ $t("contact.options") }}</span>
                      </template>
                      <span slot="noResult">{{ $t("contact.slot") }}</span>
                    </multiselect>
                  </div>
                </b-col>
                <b-col cols="12" sm="12"  md="12" lg="12" xl="5" class="mt-r input-budget">
                  <b-form-input class="input-size" v-model="form.budget" :placeholder="$t('contact.budget')" maxlength="50"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-3 mr-p">
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                  <b-form-textarea v-model="form.message" rows="8" no-resize :placeholder="$t('contact.message')" required maxlength="300"></b-form-textarea>
                </b-col>
              </b-row>
              <b-row class="my-3 mr-p">
                <b-col cols="12" sm="12" md="12" lg="12" xl="10">
                  <div class="msgError">
                    <span>{{ $t(msgError) }}</span>
                  </div>
                </b-col>
              </b-row>
              <b-row class="my-3 mr-p" align-h="end">
                <b-col cols="11" sm="12"  md="12" lg="12" xl="6" class="text-right">
                  <button type="submit" class="btn-send">{{ $t("contact.send") }}</button>
                </b-col>
                <b-col cols="12" sm="12" md="1" lg="1" xl="1"></b-col>
              </b-row>
            </b-form> 
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" xl="1"></b-col>
      </b-row>
      <b-row class="justify-content-center" :class="row_shipment">
        <b-col cols="12" class="text-center">
          <div class="confirm">
            <span class="ct-style gotham-medium">{{ $t("contact.form_ok") }}</span>
            <p>
              {{ $t("contact.form_txt1") }}
              <br>
              {{ $t("contact.form_txt2") }}
            </p>
            <button @click="returnForm" class="btn-start gotham-medium">{{ $t("contact.form_btn") }}</button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12"><div class="up-content"></div></b-col>
        <b-col cols="12" class="separation-arrow">
          <div class="up-styles gotham-bold" >
            <a class="btn-up" href="#header-section">
            <b><span>{{ $t("contact.go_up") }}</span></b>
              <icon-base class="arrow-up" icon-name="Arrow" style="transform: rotate(90deg); position: absolute; top: 4px; right: -24px;">
                <icon-arrow />
              </icon-base>
              </a>
          </div>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.gotham-bold{
  font-family: "Gotham Bold Regular";
}

.gotham-book{
  font-family: "Gotham Book Regular";
}

.gotham-light{
  font-family: "Gotham light Regular";
}

.gotham-medium{
  font-family: "Gotham Medium Regular";
}

.successful_shipment{
  display: none !important;
}

.ct-panel{
  display: table;
  height: 100vh;
  margin-top: 3%;
}

.ct-centrar{
  display: table-cell;
	vertical-align: middle;
}

.form-contact input::placeholder, .form-contact textarea::placeholder{
  color: #1D2B3C;
}

.ct-style{
  color: #ffffff;
  font-size: 45px;
  letter-spacing: 3.46px;
  line-height: 52px;
}

.msgError{
  position: absolute;
  font-family: "Gotham light Regular";
  color: #ffffff;
}
.confirm{
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  top: -500px;
}

.confirm p{
  font-family: "Gotham Book Regular";
  color: #FFFFFF;
  font-size: 20px;
  line-height: 40px;
  letter-spacing: 1.54px;
  margin: 3% 7% 2% 7%;
}

.ct-title-section {
  color: #FFFFFF;
  font-size: 32px;
  margin-left: 12%;
  line-height: 36px;
  letter-spacing: 2.46px;
}

.ct-text a[href^="tel:"], .ct-text a[href^="mailto:"], .btn-up[href]{
  color: #FFF;
  text-decoration: none;
}

.ct-text{
  color: #FFFFFF;
  font-size: 20px;
  margin: 5% 0 0 25%;
  line-height: 28px;
  letter-spacing: 1.54px;
}

.form-contact input, .form-contact textarea, .form-contact .multiselect__tags{
  border-radius: 0;
  color: #1D2B3C;
  font-size: 18px;
  font-family: "Gotham Book Regular";
  letter-spacing: 0px;
  line-height: 21px;
}

.mt-c{
  margin-top: 33%;
}

.mt-p{
  margin-top: 25%;
}

.mr-p{
  margin-right: 10% !important;
}

.btn-send:hover{
    background-position: -100% 0 !important;
    color:#04182E !important;
}

.input-services{
  padding-right: 7.5px !important;
}
.input-budget{
  padding-left: 7.5px !important;
}

.btn-send{
  /* font-family: "Gotham Book Regular"; */
  font-family: "Gotham Medium Regular";
  font-size: 18px;
  color: #FFF;
  background: transparent;
  text-decoration: none;
  border: 3px solid #FFF;
  border-radius: 0%;
  margin-top: 50px;
  margin-right: 8%;
  width: 250px;
  height: 60px;

  background-size: 200% 100% !important;
  background-image: linear-gradient(to right, transparent 50%, #fff 50%) !important;
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
  transition: background-position 1s;
}

.btn-start{
  /* font-family: "Gotham Book Regular"; */
  font-family: "Gotham Medium Regular";
  font-size: 18px;
  color: #FFF;
  background: transparent;
  text-decoration: none;
  border: 3px solid #FFF;
  border-radius: 0%;
  margin-top: 50px;
  margin-right: 8%;
  width: 250px;
  height: 60px;

  background-size: 200% 100% !important;
  background-image: linear-gradient(to right, transparent 50%, #fff 50%) !important;
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
  transition: background-position 1s;
}

#contact-section{
  background-image: linear-gradient(
      rgba(29, 43, 60, 0.5),
      rgba(29, 43, 60, 0.5)
    ), url("../assets/img/FondoContacto.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.up-styles{
  color: #FFF;
  font-size: 20px;
  position: absolute;
  bottom: 120px;
  right: 50px;
  line-height: 23px;
  letter-spacing: 1.54px;
  -webkit-transform: rotate(-90deg); 
  -moz-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.up-content{
  height: 80px;
}

.multiselect__content{
  font-size: 18px;
  font-family: "Gotham Book Regular";
  letter-spacing: 0px;
  line-height: 21px;
}

.multiselect__tags{
  max-height: 60px;
  padding-top: 6px;
  padding-left: 10px;
  height: 60px;
}

.multiselect__input, .multiselect__single{
  margin-bottom: 0px;
  margin-top: 11px;
  margin-left: -5px;
}

.multiselect__placeholder{
  /* margin-bottom: 8px; */
  color: #1D2B3C;

  font-size: 18px;
  font-family: "Gotham Book Regular";
  /* letter-spacing: 0px;
  line-height: 21px; */

  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis;
  max-width: 100%;

  padding-top: 11px;
}

.multiselect__option--highlight{
  background-color: #FFF;
  color: #04182E;
  font-size: 17px;
}
.multiselect__select{
	top: 10px;
}
.multiselect__option--highlight::after{
  background-color: #FFF;
}

.multiselect__option--selected.multiselect__option--highlight{
  background-color: #FFF;
  color: #04182E;
}

.multiselect__option--selected{
  color: #04182e;
}

.multiselect__option span{
  text-decoration: none;
  /* background: linear-gradient(currentColor, currentColor); */
  background: linear-gradient(#22C3D1, #22C3D1); 
  background-position: 0% 60%;
  background-repeat: no-repeat;
  background-size: 0% 10px;
  transition: background-size .9s;
}

.multiselect__option--selected span, .multiselect__option-selected span{
  background-size: 100% 10px;
}

.input-size{
  height: 60px !important;
}

@media (max-width: 1800px) {
  .ct-title-section {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 1.54px;
  }
  .ct-text{
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 1.23px;
  }
  .confirm p{
    font-size: 16px;
    line-height: 35px;
  }
  .ct-style{
    font-size: 40px;
  }
  .form-contact input, .form-contact textarea{
    font-size: 16px;
    line-height: 18px;
  }
  .multiselect__input, .multiselect__single{
    margin-top: 11px;
  }
  .form-contact .multiselect__tags{
    font-size: 16px;
  }
  .multiselect__placeholder{
    font-size: 16px;
    /* line-height: 18px; */
  }
  .multiselect__select{
    top: 8px;
  }
  .multiselect__content{
    font-size: 16px;
    line-height: 18px;
  }
  .up-styles{
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 1.23px;
  }
  .arrow-up{
    top: 2px !important;
  }
}

@media (max-width: 1600px) {
  .mt-p{
    margin-top: 26%;
  }
  .multiselect__tags{
    padding-top: 8px;
  }
  .input-size{
    height: 40px !important;
  }
   .multiselect__tags{
    height: 40px;
  }
  .multiselect__input, .multiselect__single{
    margin-top: 0px;
  }
  .multiselect__placeholder{
    padding-top: 0px;
  }
  .multiselect__select{
    top: 0;
  }
  .btn-send{
    font-size: 14px;
    width: 200px;
    height: 45px;
  }
}

@media (max-width: 1199px) {
  .mt-p{
    margin-top: 35%;
  }
  .mt-r{
    margin-top: 1rem;
  }
  .up-styles{
    right: 25px;
  }
  .btn-send{
    margin-right: 0;
  }
  .multiselect__tags{
    padding-top: 8px;
  }
  .input-services{
    padding-right: 15px !important;
  }
  .input-budget{
    padding-left: 15px !important;
  }
}

@media (max-width: 1024px) {
  .btn-send{
    margin-right: 0;
  }
  .mr-p{
    margin-right: 10% !important;
  }
  .up-content{
    height: 120px;
  }
  .up-styles{
    bottom: 45px;
    right: 50px;
  }
  .ct-title-section{
    margin-left: 10%;
  }
  .ct-text{
    margin: 5% 0 0 20%;
  }
  .separation-arrow{
    margin-top: 40px;
  }
}

@media (max-width: 960px){
  .ct-title-section {
    font-size: 18px;
    line-height: 26px;
    letter-spacing: 1.39px;
  }
  .ct-text{
    font-size: 15px;
    line-height: 23px;
    letter-spacing: 1.16px;
  }
  .confirm p{
    font-size: 15px;
    line-height: 25px;
  }
  .ct-style{
    font-size: 30px;
  }
  .form-contact input, .form-contact textarea{
    font-size: 15px;
    line-height: 16px;
  }
  .form-contact .multiselect__tags{
    font-size: 15px;
  }
  .multiselect__placeholder{
    font-size: 15px;
  }
  .multiselect__content{
    font-size: 15px;
    line-height: 16px;
  }
  .up-styles{
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1.08px;
  }
  .mr-p{
    margin-right: 5% !important;
  }
  .ct-title-section{
    margin-left: 8%;
  }
  .ct-text{
    margin-left: 12%;
  }
}

@media (max-width: 767px) {
  .mt-c{
    margin-top: 8%;
  }
  .mt-p{
    margin-top: 8%;
  }
  .col-center{
    justify-content: center;
  }
  .up-styles{
    bottom: 50px;
    right: 60px;
  }
  .mr-p{
    margin-right: -15px !important;
  }
  .ct-title-section{
    margin-left: 0;
  }
  .ct-text{
    margin: 5% 0 0 0%;
  }
  .input-size{
    height: 40px !important;
  }
  .multiselect__tags{
    height: 40px;
  }
  .multiselect__input, .multiselect__single{
    margin-top: 0px;
  }
  .multiselect__placeholder{
    padding-top: 0px;
  }
  .multiselect__select{
    top: 0;
  }
  .btn-send{
    font-family: "Gotham Medium Regular";
    font-size: 14px;
    width: 150px;
    height: 45px;
  }
  .btn-start{
    width: 250px !important;
    height: 40px !important;
    margin-top: 5% !important;
  }
}

@media (max-width: 575px) {
  .btn-send{
    margin-right: 0%;
    margin-top: 15%;
  }
  .mr-p{
    justify-content: center;
  }
  .col-center{
    justify-content: center;
  }
  .up-styles{
    right: 21px;
  }
  .arrow-up{
    top: -1px !important;
  }
  .ct-title-section{
    margin-left: 7%;
  }
  .ct-text{
    margin: 5% 7% 0 7%;
  }
  .form-contact{
    margin: 0 7%;
  }
}

</style>
<script>
import IconBase from './IconBase'
import IconArrow from './icons/IconArrow'

export default {
  name: 'Contact',
  components: {
		IconBase,
		IconArrow
	},
  data() {
    return {
      msgError: "",
      animationSendForm: "",
      row_shipment: "successful_shipment",
      errors: [],
      form: {
        name: '',
        email: '',
        value: [],
        issue: '',
        budget: '',
        message: ''
      },
      show: true,
      showTags: false,
      options: [
        { name: 'Branding' },
        { name: 'Motion Graphics' },
        { name: 'User Experience' },
        { name: 'Community Management' },
        { name: 'Graphic Design' },
        { name: 'Storytelling' },
        { name: 'User Interface Development' }
      ]
    }
  },
  methods: {
    returnForm(){
      this.msgError = "";
      this.form.email = '';
      this.form.name = '';
      this.form.issue = '';
      this.form.value = '';
      this.form.budget = '';
      this.form.message = '';

      this.show = false
      this.$nextTick(() => {
        this.show = true
      })

      this.animationSendForm = "animate__animated animate__fadeInLeft";
      this.row_shipment = "animate__animated animate__fadeOutDownBig"
    },
    checkForm(evt) {
      this.errors = [];

      if (!this.form.email) {
        this.errors.push('Correo requerido.');
      } else if (!this.validEmail(this.form.email)) {
        this.errors.push('Es requerido un correo valido.');
      }

      if (!this.errors.length) {
        this.animationSendForm = "animate__animated animate__fadeOutLeft";
        this.row_shipment = "animate__animated animate__fadeInUp"
        var txt = JSON.stringify(this.form);
        var obj = JSON.parse(txt);
        // console.log(obj);
        this.sendEmail(obj);
        // return true;
      }else{
        // console.log(this.errors);
        this.msgError = "contact.msg_error";
      }

      // alert(JSON.stringify(this.form))
      // console.log(JSON.stringify(this.form));
      // console.log(this.errors);

      evt.preventDefault()
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    sendEmail(obj){
      var htmlClient='<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><head><meta http-equiv="Content-Security-Policy" content="script-src "none"; connect-src "none"; object-src "none"; form-action "none";"><meta charset="UTF-8"><meta content="width=device-width, initial-scale=1" name="viewport"><meta name="x-apple-disable-message-reformatting"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta content="telephone=no" name="format-detection"><title></title>' 
       +'<!--[if (mso 16)]>'
       +'<style type="text/css">'
       +'a {text-decoration: none;}'
       +'</style>'
       +'<![endif]-->' 
       +'<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->' 
       +'<!--[if gte mso 9]>'
       +'<xml>'
       +'<o:OfficeDocumentSettings>'
       +'<o:AllowPNG></o:AllowPNG>'
       +'<o:PixelsPerInch>96</o:PixelsPerInch>'
       +'</o:OfficeDocumentSettings>'
       +'</xml>'
       +'<![endif]--><style type="text/css">#outlook a {	padding:0;}.ExternalClass {	width:100%;}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div {	line-height:100%;}.es-button {	mso-style-priority:100!important;	text-decoration:none!important;}a[x-apple-data-detectors] {	color:inherit!important;	text-decoration:none!important;	font-size:inherit!important;	font-family:inherit!important;	font-weight:inherit!important;	line-height:inherit!important;}.es-desk-hidden {	display:none;	float:left;	overflow:hidden;	width:0;	max-height:0;	line-height:0;	mso-hide:all;}@media only screen and (max-width:600px) {p, ul li, ol li, a { font-size:16px!important; line-height:150%!important } h1 { font-size:30px!important; text-align:center; line-height:120%!important } h2 { font-size:26px!important; text-align:center; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } h1 a { font-size:30px!important } h2 a { font-size:26px!important } h3 a { font-size:20px!important } .es-menu td a { font-size:13px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } .es-button { font-size:16px!important; display:block!important; border-left-width:0px!important; border-right-width:0px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } .es-desk-menu-hidden { display:table-cell!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }</style></head><body style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><div class="es-wrapper-color" style="background-color:#F6F6F6">' 
       +'<!--[if gte mso 9]>'
       +'<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">'
       +'<v:fill type="tile" color="#f6f6f6"></v:fill>'
       +'</v:background>'
       +'<![endif]--><table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top"><tr style="border-collapse:collapse"><td valign="top" style="padding:0;Margin:0"><table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%"><tr style="border-collapse:collapse"><td style="padding:0;Margin:0;background-color:#FFFFFF" bgcolor="#ffffff" align="center"><table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px"><tr style="border-collapse:collapse"><td align="left" style="padding:5px;Margin:0"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td valign="top" align="center" style="padding:0;Margin:0;width:590px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr class="es-mobile-hidden" style="border-collapse:collapse"><td style="padding:0;Margin:0;font-size:0px" align="center"><a target="_blank" href="https://marabunta.work" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, "helvetica neue", helvetica, sans-serif;font-size:14px;text-decoration:underline;color:#333333"><img class="adapt-img" src="https://xnwii.stripocdn.email/content/guids/CABINET_901b7fafb73beb3acdb04ab1a5841a86/images/5651602813859279.jpg" alt="Marabunta Mx" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" title="Marabunta Mx" width="590"></a></td></tr></table></td></tr></table></td></tr><tr style="border-collapse:collapse"><td align="left" style="padding:5px;Margin:0"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td valign="top" align="center" style="padding:0;Margin:0;width:590px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">' 
       +'<!--[if !mso]><!-- --><tr class="es-desk-hidden" style="display:none;float:left;overflow:hidden;width:0;max-height:0;line-height:0;mso-hide:all;border-collapse:collapse"><td style="padding:0;Margin:0;font-size:0px" align="center"><a target="_blank" href="https://marabunta.work" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, "helvetica neue", helvetica, sans-serif;font-size:14px;text-decoration:underline;color:#333333"><img class="adapt-img" src="https://xnwii.stripocdn.email/content/guids/CABINET_901b7fafb73beb3acdb04ab1a5841a86/images/60941602813858893.jpg" alt="" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" title=""></a></td></tr>' 
       +'<!--<![endif]--></table></td></tr></table></td></tr></table></td></tr></table></td></tr></table></div></body></html>';
      
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
        .then(() => {
            window.Email.send({
              SecureToken : "322d6962-0e3f-43ce-83e9-ed100b375248",
              To : obj.email,
              From : "no-reply@marabunta.work",
              Subject : "¡Bienvenido a Marabunta Mx!",
              Body : htmlClient,
            }).then(
                message => {
                  // console.log(message)
                  if(message != "OK"){
                    console.log("Error");
                  }else{
                    console.log("OK");
                    this.sendEmailAdmin(obj);
                  }
                }
                
            );
        })
        .catch((evt) => {
        // Failed to fetch script
          console.log(evt);
        });
    },
    sendEmailAdmin(obj){
      var htmlAdmin='<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><head><meta http-equiv="Content-Security-Policy" content="script-src "none"; connect-src "none"; object-src "none"; form-action "none";"><meta charset="UTF-8"><meta content="width=device-width, initial-scale=1" name="viewport"><meta name="x-apple-disable-message-reformatting"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta content="telephone=no" name="format-detection"><title></title> '
        +'<!--[if (mso 16)]>'
        +'    <style type="text/css">'
        +'    a {text-decoration: none;}'
        +'    </style>'
        +'    <![endif]--> '
        +'<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--> '
        +'<!--[if gte mso 9]>'
        +'<xml>'
        +'    <o:OfficeDocumentSettings>'
        +'    <o:AllowPNG></o:AllowPNG>'
        +'    <o:PixelsPerInch>96</o:PixelsPerInch>'
        +'    </o:OfficeDocumentSettings>'
        +'</xml>'
        +'<![endif]--><style type="text/css">#outlook a {	padding:0;}.ExternalClass {	width:100%;}.ExternalClass,.ExternalClass p,.ExternalClass span,.ExternalClass font,.ExternalClass td,.ExternalClass div {	line-height:100%;}.es-button {	mso-style-priority:100!important;	text-decoration:none!important;}a[x-apple-data-detectors] {	color:inherit!important;	text-decoration:none!important;	font-size:inherit!important;	font-family:inherit!important;	font-weight:inherit!important;	line-height:inherit!important;}.es-desk-hidden {	display:none;	float:left;	overflow:hidden;	width:0;	max-height:0;	line-height:0;	mso-hide:all;}@media only screen and (max-width:600px) { .contacto {font-size:24px!important; color:"#FFFFFF"!important;} p, ul li, ol li, a { font-size:16px!important; line-height:150%!important } h1 { font-size:30px!important; text-align:center; line-height:120%!important } h2 { font-size:26px!important; text-align:center; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } h1 a { font-size:30px!important } h2 a { font-size:26px!important } h3 a { font-size:20px!important } .es-menu td a { font-size:13px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } .es-button { font-size:16px!important; display:block!important; border-left-width:0px!important; border-right-width:0px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:50%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } .es-desk-menu-hidden { display:table-cell!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }</style></head><body style="width:100%;font-family:arial, "helvetica neue", helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0"><div class="es-wrapper-color" style="background-color:#F6F6F6"> '
        +'<!--[if gte mso 9]>'
        +'			<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">'
        +'				<v:fill type="tile" color="#f6f6f6"></v:fill>'
        +'			</v:background>'
        +'		<![endif]--><table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top"><tr style="border-collapse:collapse"><td valign="top" style="padding:0;Margin:0"><table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%"><tr style="border-collapse:collapse"><td align="center" style="padding:0;Margin:0"><table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px"><tr style="border-collapse:collapse"><td style="padding:0;Margin:0;padding-top:10px;padding-left:20px;padding-right:20px;background-color:#04182E" bgcolor="#04182E" align="left"> '
        +'<!--[if mso]><table style="width:560px" cellpadding="0"'
        +'                           cellspacing="0"><tr><td style="width:180px" valign="top"><![endif]--><table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left"><tr style="border-collapse:collapse"><td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:180px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td style="padding:0;Margin:0;font-size:0px" align="center"><img class="adapt-img" src="https://xnwii.stripocdn.email/content/guids/CABINET_cb902553b823275b91f5c05b364546e8/images/16541601503807608.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="100"></td></tr></table></td></tr></table> '
        +'<!--[if mso]></td><td style="width:20px"></td><td style="width:360px" valign="top"><![endif]--><table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0;width:360px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="center" style="padding:0;Margin:0;padding-top:10px;padding-bottom:10px"><p style="class="contacto" Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:32px;font-family:arial, "helvetica neue", helvetica, sans-serif;line-height:48px;color:#FFFFFF">Contacto</p></td></tr></table></td></tr></table> '
        +'<!--[if mso]></td></tr></table><![endif]--></td></tr><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td class="es-m-p0r" valign="top" align="center" style="padding:0;Margin:0;width:560px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:14px;font-family:arial, "helvetica neue", helvetica, sans-serif;line-height:21px;color:#333333">Alguien ha dejado una solicitud de contacto&nbsp;en el sitio web&nbsp;<b><a target="_blank" href="https://marabunta.work/" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, "helvetica neue", helvetica, sans-serif;font-size:14px;text-decoration:underline;color:#333333">marabunta.work</a></b>, a continuación la información:<br><br><strong>Nombre:<span>&nbsp;</span></strong>'+obj.name+'<br><br><strong>Correo:<span>&nbsp;</span></strong>'+obj.email+'<br><br><strong>Asunto:<span>&nbsp;</span></strong>'+obj.issue+'<br><br><strong>Servicios de interes:<span>&nbsp;</span></strong>'+JSON.stringify(obj.value)+'<br><br><strong>Presupuesto aproximado:<span>&nbsp;</span></strong>'+obj.budget+'<br><br><strong>Mensaje:<span>&nbsp;</span></strong>'+obj.message+'</p></td></tr></table></td></tr></table></td></tr><tr style="border-collapse:collapse"><td align="left" style="padding:0;Margin:0;padding-top:20px;padding-left:20px;padding-right:20px"><table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td valign="top" align="center" style="padding:0;Margin:0;width:560px"><table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px"><tr style="border-collapse:collapse"><td align="right" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:10px;font-family:arial, "helvetica neue", helvetica, sans-serif;line-height:20px;color:#333333">marabunta.work</p></td></tr></table></td></tr></table></td></tr></table></td></tr></table></td></tr></table></div></body></html>';
      
      this.$loadScript("https://smtpjs.com/v3/smtp.js")
        .then(() => {
            window.Email.send({
              SecureToken : "322d6962-0e3f-43ce-83e9-ed100b375248",
              To : 'hello@marabunta.work',
              From : "no-reply@marabunta.work",
              Subject : "Solicitud de contacto Marabunta Mx",
              Body : htmlAdmin,
            }).then(
                message => {
                  // console.log(message)
                  if(message != "OK"){
                    console.log("Error");
                  }else{
                    console.log("OK");
                  }
                }
            );
        })
        .catch((evt) => {
        // Failed to fetch script
          console.log(evt);
        });
    }
  }
}
</script>